var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"inline-flex"},[_c('vx-basic-icon',_vm._b({},'vx-basic-icon',_vm.icon,false)),_c('span',{staticClass:"ml-2 check-text inline-flex",class:{ unchecked: !_vm.isFulfilled, optional: !_vm.isRequired }},[_vm._v("\n            "+_vm._s(_vm.description)+"\n        ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }